import { BaseLink } from "@design-system/components/link";
import { trans } from "@mongez/localization";
import { ArrowLeft, type LucideIcon } from "lucide-react";

type AccountPageHeaderProps = {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    to: string;
  };
};

export function AccountPageHeader({
  icon: Icon,
  title,
  description,
  action,
}: AccountPageHeaderProps) {
  return (
    <header className="flex flex-col gap-5 rounded-[1.75rem] border border-slate-200 bg-gradient-to-br from-slate-50 via-white to-primary/5 p-5 dark:border-slate-800 dark:from-slate-950 dark:via-slate-900 dark:to-primary/10 sm:flex-row sm:items-center sm:justify-between sm:p-6">
      <div className="flex items-start gap-4">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-lg shadow-primary/15">
          <Icon className="h-6 w-6" />
        </span>
        <div>
          <p className="text-xs font-black uppercase tracking-wider text-primary">
            {trans("account.accountCenter")}
          </p>
          <h1 className="mt-1 text-2xl font-black text-slate-950 dark:text-white">
            {trans(title)}
          </h1>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-500 dark:text-slate-400">
            {trans(description)}
          </p>
        </div>
      </div>

      {action ? (
        <BaseLink
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-slate-950 px-4 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-slate-800 dark:bg-white dark:text-slate-950 dark:hover:bg-slate-100"
          to={action.to}
        >
          {trans(action.label)}
          <ArrowLeft className="h-4 w-4" />
        </BaseLink>
      ) : null}
    </header>
  );
}
